import { RootState } from '../../interfaces/rootState';

export const TemplateStatusSelectorCreator = (templateId: string) =>
	({ templateStatus }: RootState) => templateStatus[templateId];
